import {
  Button,
  Dialog,
  DialogActions,
  Box,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography,
  FormHelperText,
  TextField,
  Alert,
  Divider,
} from '@mui/material';
import { CustomErrorLogger } from '../../utils/CustomErrorLogger';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { useFormik } from 'formik';
import Iconify from '../Iconify';
import * as Yup from 'yup';
import axios from 'axios';
import '../../css/users/addUserDialog.css';

export const AddPoleDialog = ({
  setPoles,
  setTotalPoles,
  setFilteredPoleCount,
  openAddPole,
  setOpenAddPole,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(t('isRequired')),
      description: Yup.string().optional(),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append('name', values.name || '');
        formData.append('description', values.description || '');

        const response = await axios.post('pole', formData);
        if (response.status === 200 || response.status === 201) {
          setPoles((prev) => [...prev, response.data]);
          setTotalPoles((prev) => prev + 1);
          setFilteredPoleCount((prev) => prev + 1);
          setOpenAddPole(false);
          setErrMsg(null);
          navigate(`pole_details/${response.data.id}`);
        }
      } catch (error) {
        setErrMsg(error.message || "erreur lors de l'ajout du pôle");
        CustomErrorLogger(error, 'error adding pole in AddPoleDialog');
        console.error('Error adding pole:', error);
      } finally {
        setLoading(false);
      }
    },
  });

  const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

  const handleClose = useCallback(() => {
    setOpenAddPole(false);
    setErrMsg(null);
  }, [setOpenAddPole]);

  return (
    <Dialog open={openAddPole} fullWidth>
      <IconButton onClick={handleClose} className="addUser_icon_button">
        <Iconify icon="material-symbols:close" className="addUser_close_icon" />
      </IconButton>
      <DialogTitle className="addUser_dialog_title">{t('addPoleDialogeTitle')}</DialogTitle>
      <Divider />
      {errMsg && <Alert severity="error">{errMsg}</Alert>}
      <form onSubmit={handleSubmit}>
        <DialogContent className="addUser_dialog_content">
          <Typography className="addUser_dialog_SubTitle">{t('addPoleDialogeSubTitle')}</Typography>
          <Box className="addUser_helper_selct_box">
            <FormHelperText className="addUserInputTitle">{t('Nom')}</FormHelperText>
            <TextField
              fullWidth
              value={values.name}
              className="addUser_InputField"
              onChange={handleChange}
              onBlur={handleBlur}
              name="name"
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
          </Box>
          <Box className="addUser_helper_selct_box">
            <FormHelperText className="addUserInputTitle">
              {t('Description')} (optionnel)
            </FormHelperText>
            <TextField
              fullWidth
              value={values.description}
              className="addUser_InputField"
              onChange={handleChange}
              onBlur={handleBlur}
              name="description"
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
            />
          </Box>
        </DialogContent>
        <DialogActions className="addUser_dialog_actions">
          <Button className="addUser_button_annuler" onClick={handleClose}>
            {t('Annuler')}
          </Button>
          <LoadingButton
            className="addUser_button_valider"
            loading={loading}
            variant="contained"
            type="submit"
          >
            {t('Valider')}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};
